
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M886 504H723l35.331-132h92.412l-.074.033 3.591 13.416 10.502 39.202L886 504zM132.595 537H887l-18.506 42H113l19.595-42z","fill":"#000"}}),_c('path',{attrs:{"d":"M332 615c0 30.376-24.624 55-55 55s-55-24.624-55-55 24.624-55 55-55 55 24.624 55 55zM477 615c0 30.376-24.624 55-55 55s-55-24.624-55-55 24.624-55 55-55 55 24.624 55 55zM791 615c0 30.376-24.624 55-55 55s-55-24.624-55-55 24.624-55 55-55 55 24.624 55 55z","fill":"#000","stroke":"#fff","stroke-width":"8"}}),_c('path',{attrs:{"d":"M113 424.5c0-53.848 43.652-97.5 97.5-97.5h415c53.848 0 97.5 43.652 97.5 97.5S679.348 522 625.5 522h-415c-53.848 0-97.5-43.652-97.5-97.5z","fill":"#000"}})])
          )
        }
      }
    